var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "form-block",
    staticStyle: {
      width: "100%"
    }
  }, [_c("el-backtop", {
    attrs: {
      bottom: 100
    }
  }, [_c("div", {
    staticStyle: {
      height: "100%",
      width: "100%",
      "background-color": "var(--el-bg-color-overlay)",
      "box-shadow": "var(--el-box-shadow-lighter)",
      "text-align": "center",
      "line-height": "40px",
      color: "#1989fa",
      display: "flex",
      "align-items": "center",
      "justify-content": "center",
      "border-radius": "50%"
    }
  }, [_c("i", {
    staticClass: "el-icon-arrow-up",
    staticStyle: {
      "font-size": "20px"
    }
  })])]), _c("div", {
    staticClass: "source"
  }, [_c("el-form", {
    ref: "formData",
    staticClass: "demo-form",
    attrs: {
      model: _vm.formData,
      "status-icon": "",
      rules: _vm.rules,
      "label-position": "left"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Select Ledger Type",
      prop: "paymentType"
    }
  }, [_c("el-select", {
    attrs: {
      name: "paymentType",
      placeholder: "Select",
      clearable: ""
    },
    model: {
      value: _vm.formData.paymentType,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "paymentType", $$v);
      },
      expression: "formData.paymentType"
    }
  }, _vm._l(_vm.paymentTypeOptions, function (item) {
    return _c("el-option", {
      key: item.key,
      attrs: {
        label: item.label,
        value: item.key
      }
    });
  }), 1)], 1), _vm.formData.paymentType === "Credit Note-Item Wise" || _vm.formData.paymentType === "Debit Note-Item Wise" || _vm.formData.paymentType === "Credit Note Inward" || _vm.formData.paymentType === "Debit Note" || _vm.formData.paymentType === "Return Payment" || _vm.formData.paymentType === "Credit Note" || _vm.formData.paymentType === "Journal Voucher" ? _c("el-form-item", {
    attrs: {
      label: "Select Ledger Sub Type",
      prop: "paymentSubType"
    }
  }, [_c("el-select", {
    attrs: {
      name: "paymentSubType",
      placeholder: "Select",
      clearable: ""
    },
    model: {
      value: _vm.formData.paymentSubType,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "paymentSubType", $$v);
      },
      expression: "formData.paymentSubType"
    }
  }, _vm._l(_vm.paymentSubTypeOptions, function (item) {
    return _c("el-option", {
      key: item.key,
      attrs: {
        label: item.label,
        value: item.key
      }
    });
  }), 1), _c("el-button", {
    attrs: {
      type: "primary",
      size: "mini",
      icon: "el-icon-plus"
    },
    on: {
      click: _vm.openDialog
    }
  }), _c("el-dialog", {
    attrs: {
      title: "Add Ledger Sub Type",
      visible: _vm.dialogVisible,
      width: "30%"
    },
    on: {
      "update:visible": function ($event) {
        _vm.dialogVisible = $event;
      }
    }
  }, [_c("el-form", [_c("el-form-item", {
    attrs: {
      label: "Sub Type Name"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "Enter Sub Type Name"
    },
    model: {
      value: _vm.newSubType,
      callback: function ($$v) {
        _vm.newSubType = $$v;
      },
      expression: "newSubType"
    }
  })], 1)], 1), _c("div", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    on: {
      click: function ($event) {
        _vm.dialogVisible = false;
      }
    }
  }, [_vm._v(" Cancel ")]), _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.addSubType
    }
  }, [_vm._v(" Add ")])], 1)], 1)], 1) : _vm._e(), _vm.formData.paymentType ? _c("el-form-item", {
    attrs: {
      label: "Dealer",
      prop: "dealerId"
    }
  }, [_c("el-select", {
    staticClass: "filter-item dealer-select",
    staticStyle: {
      width: "40%"
    },
    attrs: {
      disabled: _vm.isEdit,
      filterable: "",
      clearable: "",
      remote: "",
      loading: _vm.dealerListLoading,
      "loading-text": "fetching dealers..",
      "remote-method": _vm.getDealerList,
      placeholder: "Search Dealer"
    },
    on: {
      change: _vm.handleDealerSelection
    },
    model: {
      value: _vm.formData.dealerId,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "dealerId", $$v);
      },
      expression: "formData.dealerId"
    }
  }, _vm._l(_vm.dealerList, function (dealer) {
    return _c("el-option", {
      key: dealer.id,
      attrs: {
        label: dealer.name,
        value: dealer.id
      }
    }, [_c("span", {
      staticStyle: {
        float: "left",
        "font-size": "13px"
      }
    }, [_vm._v(_vm._s(dealer.name) + " - " + _vm._s(dealer.code))]), _c("span", {
      staticStyle: {
        float: "right",
        color: "#8492a6",
        "font-size": "13px"
      }
    }, [_vm._v("   | ID: " + _vm._s(dealer.id))])]);
  }), 1)], 1) : _vm._e(), _vm.formData.paymentType === "Return Payment" ? _c("el-form-item", {
    attrs: {
      label: "Return Type",
      prop: "returnPaymentType"
    }
  }, [_c("el-select", {
    attrs: {
      name: "returnPaymentType",
      placeholder: "Select",
      clearable: ""
    },
    model: {
      value: _vm.formData.returnPaymentType,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "returnPaymentType", $$v);
      },
      expression: "formData.returnPaymentType"
    }
  }, _vm._l(["Cheque", "Demand Draft", "Inter Bank Transfer"], function (item) {
    return _c("el-option", {
      key: item,
      attrs: {
        label: item,
        value: item
      }
    });
  }), 1)], 1) : _vm._e(), _vm.formData.paymentType === "Return Payment" && _vm.formData.returnPaymentType === "Inter Bank Transfer" ? _c("el-form-item", {
    attrs: {
      label: "Return Mode",
      prop: "returnPaymentMode"
    }
  }, [_c("el-select", {
    attrs: {
      name: "returnPaymentMode",
      placeholder: "Select",
      clearable: ""
    },
    model: {
      value: _vm.formData.returnPaymentMode,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "returnPaymentMode", $$v);
      },
      expression: "formData.returnPaymentMode"
    }
  }, _vm._l(["RTGS", "NEFT", "IMPS", "UPI"], function (item) {
    return _c("el-option", {
      key: item,
      attrs: {
        label: item,
        value: item
      }
    });
  }), 1)], 1) : _vm._e(), _vm.formData.paymentType === "Return Payment" && ["Cheque", "Demand Draft"].includes(_vm.formData.returnPaymentType) ? _c("el-form-item", {
    attrs: {
      label: "Return Payment Instrument Number"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "Enter Instrument Number"
    },
    model: {
      value: _vm.formData.returnPaymentDocumentNumber,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "returnPaymentDocumentNumber", $$v);
      },
      expression: "formData.returnPaymentDocumentNumber"
    }
  })], 1) : _vm._e(), _vm.formData.paymentType === "Return Payment" && ["Cheque", "Demand Draft"].includes(_vm.formData.returnPaymentType) ? _c("el-form-item", {
    attrs: {
      label: "Favouring Party"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "Enter Favouring Party Name"
    },
    model: {
      value: _vm.formData.returnPaymentFavouringParty,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "returnPaymentFavouringParty", $$v);
      },
      expression: "formData.returnPaymentFavouringParty"
    }
  })], 1) : _vm._e(), _vm.formData.paymentType === "Journal Voucher" ? _c("el-form-item", {
    attrs: {
      label: "Action"
    }
  }, [_c("el-select", {
    attrs: {
      name: "action",
      placeholder: "Select",
      clearable: ""
    },
    model: {
      value: _vm.formData.action,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "action", $$v);
      },
      expression: "formData.action"
    }
  }, _vm._l(_vm.actions, function (item) {
    return _c("el-option", {
      key: item.key,
      attrs: {
        label: item.label,
        value: item.key
      }
    });
  }), 1)], 1) : _vm._e(), _vm.formData.paymentSubType && _vm.formData.dealerId && !(_vm.formData.paymentType === "Credit Note" || _vm.formData.paymentType === "Debit Note" || _vm.formData.paymentType === "Return Payment" || _vm.formData.paymentType === "Journal Voucher") || _vm.formData.paymentType === "Purchase" ? _c("el-form-item", {
    attrs: {
      label: "Unit Manager",
      prop: "adminId"
    }
  }, [_c("el-select", {
    attrs: {
      filterable: "",
      placeholder: "Select Unit Manager"
    },
    on: {
      change: _vm.fetchUnitList
    },
    model: {
      value: _vm.formData.adminId,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "adminId", $$v);
      },
      expression: "formData.adminId"
    }
  }, _vm._l(_vm.unitManagers, function (admin) {
    return _c("el-option", {
      key: admin.id,
      attrs: {
        label: admin.fullName,
        value: admin.id
      }
    });
  }), 1)], 1) : _vm._e(), _vm.formData.adminId && !(_vm.formData.paymentType === "Credit Note" || _vm.formData.paymentType === "Debit Note" || _vm.formData.paymentType === "Return Payment" || _vm.formData.paymentType === "Journal Voucher") || _vm.formData.paymentType === "Purchase" ? _c("el-form-item", {
    attrs: {
      label: "Unit",
      prop: "unitId"
    }
  }, [_c("el-select", {
    staticClass: "filter-item",
    attrs: {
      clearable: "",
      filterable: "",
      placeholder: "Select Unit"
    },
    model: {
      value: _vm.formData.unitId,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "unitId", $$v);
      },
      expression: "formData.unitId"
    }
  }, _vm._l(_vm.unitList, function (unit) {
    return _c("el-option", {
      key: unit.id,
      attrs: {
        label: unit.name,
        value: unit.id
      }
    }, [_vm._v(" " + _vm._s(unit.name) + " - " + _vm._s(unit.code) + " ")]);
  }), 1)], 1) : _vm._e(), _vm.formData.unitId && !(_vm.formData.paymentType === "Credit Note" || _vm.formData.paymentType === "Debit Note" || _vm.formData.paymentType === "Return Payment" || _vm.formData.paymentType === "Journal Voucher") || _vm.formData.paymentType === "Purchase" ? _c("el-form-item", {
    attrs: {
      label: "Transporter",
      prop: "dealersTransporterId"
    }
  }, [_c("el-select", {
    attrs: {
      filterable: "",
      placeholder: "Select Transporter"
    },
    model: {
      value: _vm.formData.dealersTransporterId,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "dealersTransporterId", $$v);
      },
      expression: "formData.dealersTransporterId"
    }
  }, _vm._l(_vm.transporterList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.transporter.name + "-" + item.transporter.city.name,
        value: item.id
      }
    });
  }), 1)], 1) : _vm._e(), _vm.formData.unitId && !(_vm.formData.paymentType === "Credit Note" || _vm.formData.paymentType === "Debit Note" || _vm.formData.paymentType === "Return Payment" || _vm.formData.paymentType === "Journal Voucher") || _vm.formData.paymentType === "Purchase" ? _c("el-form-item", {
    attrs: {
      label: "Billing Address",
      prop: "billingAddressId"
    }
  }, [_c("el-select", {
    attrs: {
      placeholder: "Select Billing Address"
    },
    model: {
      value: _vm.formData.billingAddressId,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "billingAddressId", $$v);
      },
      expression: "formData.billingAddressId"
    }
  }, _vm._l(_vm.addressList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.name,
        value: item.id
      }
    }, [_c("span", {
      staticStyle: {
        float: "left",
        "font-size": "11px"
      }
    }, [_vm._v(_vm._s(_vm.getFullAddress(item)))]), _c("span", {
      staticStyle: {
        float: "right",
        color: "#8492a6",
        "font-size": "11px"
      }
    }, [_vm._v("   | ID: " + _vm._s(item.id))])]);
  }), 1)], 1) : _vm._e(), _vm.formData.unitId && !(_vm.formData.paymentType === "Credit Note" || _vm.formData.paymentType === "Debit Note" || _vm.formData.paymentType === "Return Payment" || _vm.formData.paymentType === "Journal Voucher") || _vm.formData.paymentType === "Purchase" ? _c("el-form-item", {
    attrs: {
      label: "Shipping Address",
      prop: "deliveryAddressId"
    }
  }, [_c("el-select", {
    attrs: {
      placeholder: "Select Shipping Address"
    },
    model: {
      value: _vm.formData.deliveryAddressId,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "deliveryAddressId", $$v);
      },
      expression: "formData.deliveryAddressId"
    }
  }, _vm._l(_vm.addressList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.name,
        value: item.id
      }
    }, [_c("span", {
      staticStyle: {
        float: "left",
        "font-size": "11px"
      }
    }, [_vm._v(_vm._s(_vm.getFullAddress(item)))]), _c("span", {
      staticStyle: {
        float: "right",
        color: "#8492a6",
        "font-size": "11px"
      }
    }, [_vm._v("   | ID: " + _vm._s(item.id))])]);
  }), 1)], 1) : _vm._e(), _vm.formData.paymentType === "Credit Note-Item Wise" || _vm.formData.paymentType === "Debit Note-Item Wise" || _vm.formData.paymentType === "Credit Note Inward" || _vm.formData.paymentType === "Debit Note" || _vm.formData.paymentType === "Credit Note" || _vm.formData.paymentType === "Journal Receipt" || _vm.formData.paymentType === "Purchase" ? _c("el-form-item", {
    attrs: {
      label: "Is New",
      prop: "isNew"
    }
  }, [_c("el-switch", {
    model: {
      value: _vm.formData.isNew,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "isNew", $$v);
      },
      expression: "formData.isNew"
    }
  })], 1) : _vm._e(), _vm.formData.paymentType === "Debit Note-Item Wise" ? _c("el-form-item", {
    attrs: {
      label: "Is Sales",
      prop: "isSales"
    }
  }, [_c("el-switch", {
    model: {
      value: _vm.formData.isSales,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "isSales", $$v);
      },
      expression: "formData.isSales"
    }
  })], 1) : _vm._e(), _vm.formData.isNew && _vm.formData.paymentType === "Journal Receipt" ? _c("el-form-item", {
    attrs: {
      label: "Journal Receipt Bill No."
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "Enter Bill No."
    },
    model: {
      value: _vm.formData.journalReceiptBillNo,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "journalReceiptBillNo", $$v);
      },
      expression: "formData.journalReceiptBillNo"
    }
  })], 1) : _vm._e(), _vm.formData.isNew && _vm.formData.paymentType === "Purchase" ? _c("el-form-item", {
    attrs: {
      label: "Replacement Bill No."
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "Enter Bill No."
    },
    model: {
      value: _vm.formData.replacementNumber,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "replacementNumber", $$v);
      },
      expression: "formData.replacementNumber"
    }
  })], 1) : _vm._e(), _vm.formData.paymentType === "Online" ? _c("el-form-item", {
    attrs: {
      label: "Payment Mode",
      prop: "paymentMode",
      required: ""
    }
  }, [_c("el-select", {
    attrs: {
      name: "paymentMode",
      placeholder: "Select"
    },
    model: {
      value: _vm.formData.paymentMode,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "paymentMode", $$v);
      },
      expression: "formData.paymentMode"
    }
  }, _vm._l(["Credit Card", "Debit Card", "UPI"], function (item) {
    return _c("el-option", {
      key: item,
      attrs: {
        required: "",
        label: item,
        value: item
      }
    });
  }), 1)], 1) : _vm._e(), _vm.formData.paymentType === "Net Banking" || _vm.formData.paymentType === "Return Payment" ? _c("el-form-item", {
    attrs: {
      label: "Bank"
    }
  }, [_c("el-select", {
    attrs: {
      placeholder: "Select Bank"
    },
    model: {
      value: _vm.formData.bank,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "bank", $$v);
      },
      expression: "formData.bank"
    }
  }, _vm._l(_vm.banks, function (item) {
    return _c("el-option", {
      key: item.key,
      attrs: {
        label: item.lable,
        value: item.key
      }
    });
  }), 1)], 1) : _vm._e(), _vm.formData.paymentType === "Net Banking" ? _c("el-form-item", {
    attrs: {
      label: "Payment Mode",
      prop: "paymentMode",
      required: ""
    }
  }, [_c("el-select", {
    attrs: {
      name: "paymentMode",
      placeholder: "Select"
    },
    model: {
      value: _vm.formData.paymentMode,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "paymentMode", $$v);
      },
      expression: "formData.paymentMode"
    }
  }, _vm._l(["RTGS", "NEFT", "IMPS"], function (item) {
    return _c("el-option", {
      key: item,
      attrs: {
        required: "",
        label: item,
        value: item
      }
    });
  }), 1)], 1) : _vm._e(), (_vm.formData.paymentType === "Credit Note-Item Wise" || _vm.formData.paymentType === "Debit Note-Item Wise" || _vm.formData.paymentType === "Credit Note Inward" || _vm.formData.paymentType === "Debit Note" || _vm.formData.paymentType === "Credit Note" || _vm.formData.paymentType === "Purchase" || _vm.formData.paymentType === "Journal Receipt") && !_vm.formData.isNew ? _c("el-form-item", {
    attrs: {
      label: "Invoice Number"
    }
  }, [_c("el-select", {
    staticClass: "filter-item",
    attrs: {
      disabled: _vm.isEdit || !this.formData.dealerId,
      filterable: "",
      clearable: "",
      remote: "",
      loading: _vm.entryNumberListLoading,
      "loading-text": "fetching invoices..",
      "remote-method": _vm.getEntryNumberList,
      placeholder: "Search Invoice Number"
    },
    on: {
      change: _vm.handleEntryNumber
    },
    model: {
      value: _vm.formData.ordersDispatchId,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "ordersDispatchId", $$v);
      },
      expression: "formData.ordersDispatchId"
    }
  }, _vm._l(_vm.entryNumbers, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.invoiceNumber,
        value: item.id
      }
    }, [_c("span", {
      staticStyle: {
        float: "left",
        "font-size": "13px"
      }
    }, [_vm._v(_vm._s(item.invoiceNumber))])]);
  }), 1)], 1) : _vm._e(), _vm.formData.isNew && !(_vm.formData.paymentType === "Credit Note" || _vm.formData.paymentType === "Debit Note" || _vm.formData.paymentType === "Return Payment" || _vm.formData.paymentType === "Journal Receipt") ? _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.listLoading,
      expression: "listLoading"
    }],
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.ordersProducts,
      border: "",
      fit: "",
      "highlight-current-row": "",
      size: "mini"
    }
  }, [_c("el-table-column", {
    attrs: {
      type: "index",
      width: "50"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "Product",
      prop: "productId",
      width: "250"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function (scope) {
        return [_c("el-select", {
          attrs: {
            filterable: "",
            remote: "",
            clearable: "",
            "remote-method": _vm._getProductList,
            loading: _vm.productListLoading,
            placeholder: "Select Product",
            size: "mini"
          },
          model: {
            value: _vm.selectedVariationId,
            callback: function ($$v) {
              _vm.selectedVariationId = $$v;
            },
            expression: "selectedVariationId"
          }
        }, _vm._l(_vm.products, function (product) {
          return _c("el-option-group", {
            key: product.id,
            attrs: {
              label: product.name
            }
          }, _vm._l(product.productsVariation, function (item) {
            return _c("el-option", {
              key: item.id,
              attrs: {
                label: product.name + "-" + item.name,
                value: item.id
              }
            }, [_c("span", [_vm._v(_vm._s(item.name))])]);
          }), 1);
        }), 1), _c("el-button", {
          attrs: {
            size: "mini",
            type: "success",
            icon: "el-icon-plus"
          },
          on: {
            click: function ($event) {
              return _vm.addVariation(scope);
            }
          }
        })];
      }
    }, {
      key: "default",
      fn: function (scope) {
        return [scope.row.name ? _c("strong", {
          staticClass: "text-small"
        }, [_vm._v(" " + _vm._s(scope.row.name) + " ")]) : _vm._e()];
      }
    }], null, false, 4174172486)
  }), _c("el-table-column", {
    attrs: {
      label: "Variation",
      prop: "productsVariationId",
      width: "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [scope.row.variationName ? _c("strong", {
          staticClass: "text-small"
        }, [_vm._v(" " + _vm._s(scope.row.variationName) + " (" + _vm._s(scope.row.oldMrp || 0) + ") ")]) : _vm._e()];
      }
    }], null, false, 1694495259)
  }), _c("el-table-column", {
    attrs: {
      label: "MRP",
      prop: "mrp",
      width: "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-input-number", {
          attrs: {
            size: "mini",
            min: 0,
            step: 0.01,
            "step-strictly": ""
          },
          model: {
            value: scope.row.mrp,
            callback: function ($$v) {
              _vm.$set(scope.row, "mrp", $$v);
            },
            expression: "scope.row.mrp"
          }
        })];
      }
    }], null, false, 3254010308)
  }), _c("el-table-column", {
    attrs: {
      label: "Quantity",
      width: "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-input-number", {
          attrs: {
            size: "mini",
            min: 0,
            step: 1,
            "step-strictly": ""
          },
          on: {
            change: function ($event) {
              return _vm.handleQuantity(scope.$index);
            }
          },
          model: {
            value: _vm.ordersProducts[scope.$index].quantity,
            callback: function ($$v) {
              _vm.$set(_vm.ordersProducts[scope.$index], "quantity", $$v);
            },
            expression: "ordersProducts[scope.$index].quantity"
          }
        })];
      }
    }], null, false, 1783107561)
  }), _vm.formData.paymentType === "Credit Note-Item Wise" || _vm.formData.paymentType === "Credit Note Inward" || _vm.formData.paymentType === "Purchase" ? _c("el-table-column", {
    attrs: {
      label: "MOQ Discount (%)",
      width: "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-input-number", {
          attrs: {
            size: "mini",
            min: 0,
            max: 100,
            precision: 2,
            step: 0.01
          },
          on: {
            change: value => _vm.handleDiscountChange("moq", value, scope.$index)
          },
          model: {
            value: scope.row.moqDiscount,
            callback: function ($$v) {
              _vm.$set(scope.row, "moqDiscount", $$v);
            },
            expression: "scope.row.moqDiscount"
          }
        })];
      }
    }], null, false, 1313813249)
  }) : _vm._e(), _vm.formData.paymentType === "Credit Note-Item Wise" || _vm.formData.paymentType === "Credit Note Inward" || _vm.formData.paymentType === "Purchase" ? _c("el-table-column", {
    attrs: {
      label: "Policy Discount (%)",
      width: "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-input-number", {
          attrs: {
            size: "mini",
            min: 0,
            max: 100,
            precision: 2,
            step: 0.01
          },
          on: {
            change: value => _vm.handleDiscountChange("policy", value, scope.$index)
          },
          model: {
            value: scope.row.policyDiscount,
            callback: function ($$v) {
              _vm.$set(scope.row, "policyDiscount", $$v);
            },
            expression: "scope.row.policyDiscount"
          }
        })];
      }
    }], null, false, 3678392129)
  }) : _vm._e(), _vm.formData.paymentType === "Credit Note-Item Wise" || _vm.formData.paymentType === "Credit Note Inward" || _vm.formData.paymentType === "Purchase" ? _c("el-table-column", {
    attrs: {
      label: "Schemes Discount (%)",
      width: "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-input-number", {
          attrs: {
            size: "mini",
            min: 0,
            max: 100,
            precision: 2,
            step: 0.01
          },
          on: {
            change: value => _vm.handleDiscountChange("schemes", value, scope.$index)
          },
          model: {
            value: scope.row.schemesDiscount,
            callback: function ($$v) {
              _vm.$set(scope.row, "schemesDiscount", $$v);
            },
            expression: "scope.row.schemesDiscount"
          }
        })];
      }
    }], null, false, 1005692715)
  }) : _vm._e(), _vm.formData.paymentType === "Credit Note-Item Wise" || _vm.formData.paymentType === "Credit Note Inward" || _vm.formData.paymentType === "Purchase" ? _c("el-table-column", {
    attrs: {
      label: "Extra Discount (%)",
      width: "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-input-number", {
          attrs: {
            size: "mini",
            min: 0,
            max: 100,
            precision: 2,
            step: 0.01
          },
          on: {
            change: value => _vm.handleDiscountChange("extra", value, scope.$index)
          },
          model: {
            value: scope.row.extraDiscount,
            callback: function ($$v) {
              _vm.$set(scope.row, "extraDiscount", $$v);
            },
            expression: "scope.row.extraDiscount"
          }
        })];
      }
    }], null, false, 676562433)
  }) : _vm._e(), _c("el-table-column", {
    attrs: {
      label: "Amount",
      width: "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-input-number", {
          attrs: {
            disabled: "",
            size: "mini",
            min: 0,
            precision: 2,
            step: 0.1
          },
          model: {
            value: scope.row.amount,
            callback: function ($$v) {
              _vm.$set(scope.row, "amount", $$v);
            },
            expression: "scope.row.amount"
          }
        })];
      }
    }], null, false, 2052947892)
  }), _c("el-table-column", {
    attrs: {
      align: "center",
      width: "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-button", {
          attrs: {
            type: "danger",
            icon: "el-icon-delete",
            circle: ""
          },
          on: {
            click: function ($event) {
              return _vm.removeProduct(scope.$index, scope.row);
            }
          }
        })];
      }
    }], null, false, 1756440040)
  })], 1) : _vm._e(), _vm.formData.ordersDispatchId && !(_vm.formData.paymentType === "Credit Note" || _vm.formData.paymentType === "Debit Note" || _vm.formData.paymentType === "Return Payment" || _vm.formData.paymentType === "Journal Receipt") ? _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.productListLoading,
      expression: "productListLoading"
    }],
    ref: "productsTable",
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.products,
      border: "",
      fit: "",
      "highlight-current-row": "",
      size: "mini"
    }
  }, [_c("el-table-column", {
    attrs: {
      label: "ID",
      prop: "productsVariationId",
      width: "50"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "Name",
      prop: "productName",
      width: "230"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "Quantity Dispatched",
      prop: "quantity",
      width: "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-input-number", {
          attrs: {
            size: "mini",
            min: 0,
            step: 1,
            "step-strictly": "",
            disabled: ""
          },
          model: {
            value: scope.row.quantity,
            callback: function ($$v) {
              _vm.$set(scope.row, "quantity", $$v);
            },
            expression: "scope.row.quantity"
          }
        })];
      }
    }], null, false, 178586232)
  }), _c("br"), _c("el-table-column", {
    attrs: {
      label: "MRP",
      prop: "mrp",
      width: "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-input", {
          attrs: {
            size: "mini"
          },
          model: {
            value: scope.row.mrp,
            callback: function ($$v) {
              _vm.$set(scope.row, "mrp", $$v);
            },
            expression: "scope.row.mrp"
          }
        })];
      }
    }], null, false, 2460717034)
  }), _c("el-table-column", {
    attrs: {
      label: "Quantity",
      width: "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-input-number", {
          attrs: {
            size: "mini",
            min: 0,
            step: 1,
            "step-strictly": ""
          },
          on: {
            change: function ($event) {
              return _vm.handleQuantity(scope.$index);
            }
          },
          model: {
            value: _vm.quantity,
            callback: function ($$v) {
              _vm.quantity = $$v;
            },
            expression: "quantity"
          }
        })];
      }
    }], null, false, 3659184078)
  }), _vm.formData.paymentType === "Credit Note-Item Wise" || _vm.formData.paymentType === "Credit Note Inward" || _vm.formData.paymentType === "Purchase" ? _c("el-table-column", {
    attrs: {
      label: "MOQ Discount (%)",
      width: "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-input-number", {
          attrs: {
            size: "mini",
            min: 0,
            max: 100,
            precision: 2,
            step: 0.01
          },
          on: {
            change: value => _vm.handleDiscountChange1("moq", value, scope.$index, scope.row)
          },
          model: {
            value: scope.row.moqDiscount,
            callback: function ($$v) {
              _vm.$set(scope.row, "moqDiscount", $$v);
            },
            expression: "scope.row.moqDiscount"
          }
        })];
      }
    }], null, false, 3148534904)
  }) : _vm._e(), _vm.formData.paymentType === "Credit Note-Item Wise" || _vm.formData.paymentType === "Credit Note Inward" || _vm.formData.paymentType === "Purchase" ? _c("el-table-column", {
    attrs: {
      label: "Policy Discount (%)",
      width: "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-input-number", {
          attrs: {
            size: "mini",
            min: 0,
            max: 100,
            precision: 2,
            step: 0.01
          },
          on: {
            change: value => _vm.handleDiscountChange1("policy", value, scope.$index, scope.row)
          },
          model: {
            value: scope.row.policyDiscount,
            callback: function ($$v) {
              _vm.$set(scope.row, "policyDiscount", $$v);
            },
            expression: "scope.row.policyDiscount"
          }
        })];
      }
    }], null, false, 731860882)
  }) : _vm._e(), _vm.formData.paymentType === "Credit Note-Item Wise" || _vm.formData.paymentType === "Credit Note Inward" || _vm.formData.paymentType === "Purchase" ? _c("el-table-column", {
    attrs: {
      label: "Schemes Discount (%)",
      width: "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-input-number", {
          attrs: {
            size: "mini",
            min: 0,
            max: 100,
            precision: 2,
            step: 0.01
          },
          on: {
            change: value => _vm.handleDiscountChange1("schemes", value, scope.$index, scope.row)
          },
          model: {
            value: scope.row.schemesDiscount,
            callback: function ($$v) {
              _vm.$set(scope.row, "schemesDiscount", $$v);
            },
            expression: "scope.row.schemesDiscount"
          }
        })];
      }
    }], null, false, 2537443794)
  }) : _vm._e(), _c("el-table-column", {
    attrs: {
      label: "Amount",
      width: "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-input-number", {
          attrs: {
            disabled: "",
            size: "mini",
            min: 0,
            precision: 2,
            step: 1
          },
          model: {
            value: scope.row.CnDnAmount,
            callback: function ($$v) {
              _vm.$set(scope.row, "CnDnAmount", $$v);
            },
            expression: "scope.row.CnDnAmount"
          }
        })];
      }
    }], null, false, 1685943437)
  })], 1) : _vm._e(), _vm.formData.paymentType !== "Credit Note-Item Wise" && _vm.formData.paymentType !== "Debit Note-Item Wise" && _vm.formData.paymentType !== "Credit Note Inward" && _vm.formData.paymentType !== "Purchase" ? _c("el-form-item", {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      label: "Amount",
      prop: "amount"
    }
  }, [_c("el-input-number", {
    attrs: {
      disabled: _vm.isEdit,
      min: 0,
      "controls-position": "right"
    },
    model: {
      value: _vm.formData.amount,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "amount", $$v);
      },
      expression: "formData.amount"
    }
  })], 1) : _vm._e(), _vm.formData.paymentType === "Credit Note" || _vm.formData.paymentType === "Debit Note" ? _c("el-form-item", {
    attrs: {
      label: "Apply GST",
      prop: "applyGST"
    }
  }, [_c("el-switch", {
    model: {
      value: _vm.formData.applyGST,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "applyGST", $$v);
      },
      expression: "formData.applyGST"
    }
  })], 1) : _vm._e(), _vm.formData.applyGST ? _c("el-form-item", {
    attrs: {
      label: "Select GST Type"
    }
  }, [_c("el-select", {
    attrs: {
      placeholder: "Select",
      clearable: ""
    },
    on: {
      change: _vm.updateAmountForGST
    },
    model: {
      value: _vm.formData.gstType,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "gstType", $$v);
      },
      expression: "formData.gstType"
    }
  }, _vm._l(_vm.gstOptions, function (item) {
    return _c("el-option", {
      key: item.key,
      attrs: {
        label: item.label,
        value: item.key
      }
    });
  }), 1)], 1) : _vm._e(), _c("el-form-item", {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      label: "Date"
    }
  }, [_c("el-date-picker", {
    attrs: {
      type: "date",
      placeholder: "Select date"
    },
    model: {
      value: _vm.formData.createdTimestamp,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "createdTimestamp", $$v);
      },
      expression: "formData.createdTimestamp"
    }
  })], 1), _c("el-form-item", {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      label: "Entered Date"
    }
  }, [_c("el-date-picker", {
    attrs: {
      type: "date",
      placeholder: "Select date",
      disabled: ""
    },
    model: {
      value: _vm.formData.actualCreatedTimestamp,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "actualCreatedTimestamp", $$v);
      },
      expression: "formData.actualCreatedTimestamp"
    }
  })], 1), _vm.formData.paymentType === "Online" || _vm.formData.paymentType === "Cheque" || _vm.formData.paymentType === "Net Banking" ? _c("el-form-item", {
    attrs: {
      label: "Transaction Reference",
      prop: "transactionReference"
    }
  }, [_c("el-input", {
    attrs: {
      name: "transactionReference"
    },
    model: {
      value: _vm.formData.transactionReference,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "transactionReference", $$v);
      },
      expression: "formData.transactionReference"
    }
  })], 1) : _vm._e(), _c("el-form-item", {
    attrs: {
      label: "Description",
      prop: "comments"
    }
  }, [_c("el-input", {
    attrs: {
      type: "textarea"
    },
    on: {
      change: _vm.handleChange
    },
    model: {
      value: _vm.formData.comments,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "comments", $$v);
      },
      expression: "formData.comments"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      prop: "fromTally",
      label: "From Tally"
    }
  }, [_c("el-switch", {
    attrs: {
      "active-text": "Yes",
      "inactive-text": "No",
      disabled: !_vm._isSuperAdmin()
    },
    model: {
      value: _vm.formData.fromTally,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "fromTally", $$v);
      },
      expression: "formData.fromTally"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Upload Supporting Document"
    }
  }, [_c("el-upload", {
    staticClass: "upload-demo",
    attrs: {
      action: "https://api.conasmyle.in/ledgers/upload",
      accept: ".pdf",
      "on-success": _vm.handleUploadSuccess
    }
  }, [_c("el-button", {
    attrs: {
      size: "small",
      type: "primary"
    }
  }, [_vm._v(" Click to upload ")])], 1)], 1), _c("el-form-item", [_c("el-button", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }, {
      name: "waves",
      rawName: "v-waves"
    }],
    attrs: {
      type: "success"
    },
    on: {
      click: _vm.handleButtonClick
    }
  }, [["Credit Note", "Credit Note-Item Wise", "Purchase", "Debit Note"].includes(_vm.formData.paymentType) ? [_vm.savedLedgerId === null ? [_vm._v(" " + _vm._s("Save & Preview") + " ")] : [_vm._v(" " + _vm._s("Save & Exit") + " ")]] : [_vm._v(" " + _vm._s(_vm.$t("global.form.save")) + " ")]], 2), _vm._v("    "), _vm.savedLedgerId !== null && ["Credit Note", "Credit Note-Item Wise", "Purchase", "Debit Note", "Credit Note Inward"].includes(_vm.formData.paymentType) ? _c("el-button", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }, {
      name: "waves",
      rawName: "v-waves"
    }],
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.previewPdf
    }
  }, [_vm._v(" Preview PDF ")]) : _vm._e()], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };